export default "__VITE_ASSET__CF9H8dHu__"